import React from 'react';
import {FormattedMessage} from 'react-intl';
import {config} from '../../config/config';
const cdn = config.get('baseUrls').cdn;

export function GoogleButton({target}) {
  return (
    <a href={target}>
      <img src={`${cdn}cocobox/img/login2/google-circle.png`} alt="Logga in med Google	" draggable="false" />
      <br />
      <FormattedMessage id="loginsite.google" tagName="span" />
    </a>
  );
}
